import { domainSummarySchema } from "@redotech/redo-dns-common/schema";
import * as z from "zod";

/**
 * Idempotent: re-adding a domain this team already holds returns it. Rejects a
 * URL, an IP, a bare suffix, or a second unverified domain.
 */
export const addDnsDomain = {
  name: "addDnsDomain" as const,
  input: z.object({ domain: z.string() }),
  output: z.object({ domain: domainSummarySchema }),
};
